import React from 'react';
import classNames from 'classnames';

import {Layouts} from '@components';
import {Props} from './types';

import './index.scss';

const Main: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  return (
    <div className={classNames('a__commercial', {after: isAuthed})}>
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}
      <div className="b__content-main">
        <div className="w__commercial-content">
          <div className="w__commercial-header">
            <span>特定商取引に基づく表記</span>
          </div>
          <div className="w__commercial-messages">
            {/* ダミー文言 */}
            <div className="w__commercial-column">
              <div className="b__commercial-title">事業者</div>
              株式会社ターン・アンド・フロンティア
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">代表者</div> 大久保 哲也
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">ホームページ</div>
              https://www.taf-jp.com/
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">所在地</div> 〒550-0013
              大阪府大阪市西区新町1丁目5番7 四ツ橋ビルディング3階
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">電話番号</div>
              06-7878-8555
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">販売価格帯</div>
              各商品に表記された価格に準じます
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">代金の支払方法</div>
              クレジットカード決済
            </div>
            <div className="w__commercial-column">
              <div className="b__commercial-title">代金の支払時期</div>
              即日
            </div>
          </div>
        </div>
      </div>
      {!isAuthed && <Layouts.Footer.Main />}
    </div>
  );
};

export default Main;
